import { Clients, useQuery } from "../apollo";
import { GetUserQuery } from "../graphql/queries/getUser";
import { GetUserRequestType } from "../types/user";

type GetUserResponseType = {
  getUser: {
    email: string;
    firstName: string;
    lastName: string;
    groups: string[];
    roles: string[];
    status: string;
    username: string;
    attributes: Record<string, string>;
  };
};

export const useGetUser = (username: string, region: string) => {
  return useQuery<GetUserResponseType, GetUserRequestType>(
    Clients.UPS,
    GetUserQuery,
    {
      variables: { username, region },
      skip: !username || !region,
    },
  );
};
